// Displays current app version + short git SHA in the header.
// VERCEL_GIT_COMMIT_SHA is exposed at build time by Vercel automatically.
// REACT_APP_VERSION can be bumped manually for major milestones.
const APP_VERSION = 'v0.7'
const COMMIT_SHA = process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA
  || process.env.VERCEL_GIT_COMMIT_SHA
  || 'dev'
export const SHORT_SHA = COMMIT_SHA.slice(0, 7)
export const VERSION_LABEL = `${APP_VERSION} · ${SHORT_SHA}`
